import { render, staticRenderFns } from "./AdminIconOffices.vue?vue&type=template&id=151f7c40&scoped=true"
import script from "./AdminIconOffices.vue?vue&type=script&lang=ts"
export * from "./AdminIconOffices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f7c40",
  null
  
)

export default component.exports